<span [pTooltip]="tooltip" [tooltipPosition]="tooltipIconPosition" class="custom-checkbox"
  [tooltipStyleClass]="tooltipStyleClass"
  [ngClass]="{'custom-checkbox-gray': grayCheckbox, 'custom-checkbox-dark-gray': darkGrayCheckbox, 'custom-checkbox-green': greenCheckbox}">

  <p-checkbox styleClass="checkbox" [labelStyleClass]="labelInputStyleClass" binary="true" [checkboxIcon]="checkboxIcon"
    [(ngModel)]="isChecked" (onChange)="handleChange($event)" [disabled]="disabled" [inputId]="inputId"
    *ngIf="!label.includes('<')" [label]="label">
  </p-checkbox>

  <!-- Checkbox for innerHTML enabled -->
  <p-checkbox styleClass="checkbox" [labelStyleClass]="labelInputStyleClass" binary="true" [checkboxIcon]="checkboxIcon"
    [(ngModel)]="isChecked" (onChange)="handleChange($event)" [disabled]="disabled" [inputId]="inputId"
    *ngIf="label.includes('<')">
  </p-checkbox>

  <label *ngIf="label.includes('<')" [innerHTML]="label" [for]="inputId" class="custom-checkbox-label"></label>

</span>
